export default __webpack_public_path__ + "static/media/rfox-bnb.68222ca7.svg";